import { Component, input, OnInit } from '@angular/core';
import { LocalizationModule } from "../../../../modules/localization/localization.module";

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  standalone: true,
  imports: [LocalizationModule]
})
export class LabelComponent implements OnInit {
  value = input<string>();
  required = input<boolean>();
  htmlFor = input<string>();
  constructor() { }

  ngOnInit() { }

}
